import React, { useEffect, useRef, useState } from "react"

import { ActionIcon, Avatar, FileButton, Menu, useMantineTheme } from "@mantine/core"

import { downloadCenterPaths } from "app/static/frontend/imports/desktopPaths"
import { Icon } from "@/components/Icon"
import { useFormContext } from "react-hook-form"

import { useStyles } from "@/components/AvatarUpload/AvatarUpload.styles"

export const AvatarUpload = () => {
    const formContext = useFormContext()

    const [imageUrl, setImageUrl] = useState("")
    const [isUploading, setIsUploading] = useState(false)

    const resetRef = useRef(null)
    const menuButtonRef = useRef(null)

    const theme = useMantineTheme()
    const { classes } = useStyles()

    useEffect(() => {
        if (formContext.getValues("image_url")) {
            setImageUrl(formContext.getValues("image_url"))
        }
    }, [formContext])

    const handleChange = (file) => {
        file && uploadImage(file)
    }

    const removeImage = () => {
        // https://mantine.dev/core/file-button/#reset-file
        setImageUrl("")
        formContext.setValue("image_url", "")
        resetRef.current?.()
    }

    const uploadImage = async (file) => {
        setIsUploading(true)
        const data = new FormData()
        data.append("file", file)

        try {
            const response = await fetch(downloadCenterPaths.uploadAttachment, {
                method: "POST",
                headers: {
                    "x-csrftoken": Userdata.csrftoken,
                },
                body: data,
            })

            if (!response.ok) {
                throw new Error("Unable to upload image")
            }

            const json = await response.json()
            const imageUrl = json[0].url

            if (imageUrl) {
                setImageUrl(imageUrl)
                formContext.setValue("image_url", imageUrl)
                // manually close the dropdown here
                menuButtonRef.current?.click()
            }
        } catch (error) {
            console.error(error)
        } finally {
            setIsUploading(false)
        }
    }

    return (
        <div className={classes.avatarUploadContainer}>
            <Avatar src={imageUrl} radius={120} size={64} />
            <Menu shadow="xl" position="bottom-start" width={160}>
                <Menu.Target>
                    <ActionIcon
                        aria-label="Profile picture menu"
                        className={classes.menuButton}
                        radius={24}
                        size={24}
                        ref={menuButtonRef}
                    >
                        <Icon icon="pen" iconFamily="far" size="sm" />
                    </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                    <FileButton accept="image/png,image/jpeg" onChange={handleChange} resetRef={resetRef}>
                        {(props) => (
                            <Menu.Item
                                className={classes.uploadButton}
                                closeMenuOnClick={false} // closing the menu unrenders the component which prevents the input file value from being set
                                disabled={isUploading}
                                icon={<Icon icon="camera" iconFamily="far" />}
                                {...props}
                            >
                                Upload new
                            </Menu.Item>
                        )}
                    </FileButton>
                    <Menu.Divider />
                    <Menu.Item
                        className={classes.removeButton}
                        color={theme.colors.red[9]}
                        icon={<Icon icon="trash" iconFamily="far" />}
                        onClick={removeImage}
                    >
                        Remove
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </div>
    )
}
